"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Façade for the selection overlays system
 * Facilitates communication between overlay items and the client
 */
var SelectionStore = /** @class */ (function () {
    function SelectionStore() {
        this.selection = new Set();
        this.listeners = new Set();
    }
    Object.defineProperty(SelectionStore.prototype, "size", {
        /**
         * Amount of selected items
         */
        get: function () {
            return this.selection.size;
        },
        enumerable: true,
        configurable: true
    });
    SelectionStore.prototype.isSelected = function (id) {
        return this.selection.has(id);
    };
    SelectionStore.prototype.getSelectedIds = function () {
        return new Set(this.selection);
    };
    SelectionStore.prototype.selectItem = function (id) {
        var oldSize = this.selection.size;
        this.selection.add(id);
        if (this.selection.size > oldSize) {
            this.lastSelectedId = id;
            this.notifySelectionChange(id, true);
        }
    };
    SelectionStore.prototype.deselectItem = function (id) {
        this.lastSelectedId = null;
        if (this.selection.delete(id)) {
            this.notifySelectionChange(id, false);
        }
    };
    /**
     * Replace the current selection set
     */
    SelectionStore.prototype.setSelectedIds = function (ids) {
        var e_1, _a;
        var _this = this;
        var remainder = new Set(this.selection);
        try {
            for (var ids_1 = __values(ids), ids_1_1 = ids_1.next(); !ids_1_1.done; ids_1_1 = ids_1.next()) {
                var id = ids_1_1.value;
                this.selectItem(id);
                remainder.delete(id);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (ids_1_1 && !ids_1_1.done && (_a = ids_1.return)) _a.call(ids_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        remainder.forEach(function (_, id) { return _this.deselectItem(id); });
        this.lastSelectedId = null;
    };
    /**
     * Select a range of items, starting for the last selected item
     * If the 'bulkSelectAdapter' is not set then only 'untilItemId' is selected
     */
    SelectionStore.prototype.rangeSelect = function (untilItemId, allItems, isSelectable) {
        var _this = this;
        if (isSelectable === void 0) { isSelectable = function () { return true; }; }
        var rangeItems = [];
        var startIdx = allItems.findIndex(function (it) { return it.id === _this.lastSelectedId || it.id === untilItemId; });
        var stopId = allItems[startIdx].id === this.lastSelectedId ? untilItemId : this.lastSelectedId;
        for (var i = startIdx; i < allItems.length; ++i) {
            rangeItems.push(allItems[i]);
            if (allItems[i].id === stopId) {
                rangeItems.forEach(function (it) { return isSelectable(it) && _this.selectItem(it.id); });
                break;
            }
        }
    };
    SelectionStore.prototype.addListener = function (listener) {
        this.listeners.add(listener);
    };
    SelectionStore.prototype.removeListener = function (listener) {
        this.listeners.delete(listener);
    };
    SelectionStore.prototype.notifySelectionChange = function (id, selected) {
        this.listeners.forEach(function (l) { return l(id, selected); });
    };
    return SelectionStore;
}());
exports.SelectionStore = SelectionStore;
/**
 * A general purpose mechanism for selecting a subset of items
 *
 * @param options options for overlay initialization
 */
function makeSelectionOverlay(options) {
    return function (item, img) {
        var selectionView;
        var setVisualState = function (shouldSelect) {
            if (shouldSelect && !selectionView) {
                selectionView = options.renderSelection();
                img.appendChild(selectionView);
            }
            else if (!shouldSelect && selectionView) {
                img.removeChild(selectionView);
                selectionView = null;
            }
        };
        var onStoreUpdate = function (itemId, selected) {
            if (itemId === item.id) {
                setVisualState(selected);
            }
        };
        var clickListener = function (ev) {
            if (options.bulkSelectAdapter && ev.shiftKey) {
                options.store.rangeSelect(item.id, options.bulkSelectAdapter(), options.isSelectable);
            }
            else if (selectionView) {
                options.store.deselectItem(item.id);
            }
            else {
                (!options.isSelectable || options.isSelectable(item)) && options.store.selectItem(item.id);
            }
            ev.stopImmediatePropagation();
        };
        setVisualState(options.store.isSelected(item.id));
        options.store.addListener(onStoreUpdate);
        img.addEventListener('click', clickListener);
        return function () {
            options.store.removeListener(onStoreUpdate);
            img.removeEventListener('click', clickListener);
            setVisualState(false);
        };
    };
}
exports.makeSelectionOverlay = makeSelectionOverlay;
